import { FC } from 'react'
import { Label } from '@progress/kendo-react-labels'
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs'
import { StackLayout, Card } from '@progress/kendo-react-layout'

import {
  ExpenseSelect,
  BranchSelect,
  StatusSelect,
  ProgressStatusSelect,
  ConstructionPeriodYearsDropDownList,
  EvaluationSelect,
  NormalStatusSelect,
  ConstrTypeSelect
} from '../../../components/parts'
import {
  SimulationBuildingSearchActions,
  useAppDispatch,
  useAppSelector
} from '../../../stores'

export const SearchCondition: FC<{}> = () => {
  const searchCondition = useAppSelector(
    (state) => state.simulationbuildingsearch.simulationBuildingSearch
  )
  const dispatch = useAppDispatch()

  /**
   * 調達番号
   */
  const handleProcurementNo = (event: InputChangeEvent) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        procurementNo: event.value
      })
    )
  }

  /**
   * 費目
   */
  const handleExpense = (valueList: string[]) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        expense: valueList[0]
      })
    )
  }

  /**
   * 費目要否
   */
  const handleExpenseNotApplicableFlg = (value: string[]) => {
    const valNumArray = value.map((item) => {
      return Number(item)
    })
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        expenseNotApplicableFlg: valNumArray
      })
    )
  }

  /**
   * 更新ステータス
   */
  const handleUpdSts = (value: string[]) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        updSts: value
      })
    )
  }

  /**
   * 進捗状況
   */
  const handleOpportunityProgress = (value: string[]) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        opportunityProgressKbn: value
      })
    )
  }

  /**
   * 評価
   */
  const handleEvaluationValue = (value: string[]) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        evaluationValue: value
      })
    )
  }

  /**
   * 支店
   */
  const handleBranch = (valueList: string[]) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        branch: valueList
      })
    )
  }

  /**
   * 工事名
   */
  const handleConstrucionNm = (event: InputChangeEvent) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        constructionNm: event.value
      })
    )
  }

  /**
   * 工事種別
   */
  const handleConstructionCd = (valueList: string[]) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        constructionCd: valueList
      })
    )
  }

  /**
   * 工期FROM
   */
  const handleStartScheduleFrom = (value: number) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        scheduleFrom: value
      })
    )
  }

  /**
   * 工期TO
   */
  const handleScheduleTo = (value: number) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        scheduleTo: value
      })
    )
  }

  /**
   * 所長
   */
  const handleChief = (event: InputChangeEvent) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        chief: event.value
      })
    )
  }

  /**
   * 担当者
   */
  const handlePerson = (event: InputChangeEvent) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        person: event.value
      })
    )
  }

  /**
   * 業者
   */
  const handleSupplierNm = (event: InputChangeEvent) => {
    dispatch(
      SimulationBuildingSearchActions.setSimulationBuildingSearch({
        ...searchCondition,
        supplierNm: event.value
      })
    )
  }

  return (
    <>
      <div style={{ display: 'flex' }}>
        <h3>検索条件</h3>
        <div
          style={{ display: 'flex', alignItems: 'center', marginLeft: '40px', flex: 1 }}
        >
          <Card
            className="update-card-body"
            style={{
              width: '7%',
              height: '40%',
              display: 'inline-block',
              textAlign: 'left'
            }}
          ></Card>
          <div style={{ width: '93%', display: 'inline-block' }}>
            <Label className="update-color">：手積内容が変更された物件</Label>
          </div>
        </div>
      </div>
      <StackLayout gap={5} orientation="vertical">
        <Label>調達番号</Label>
        <Input
          onChange={handleProcurementNo}
          value={searchCondition.procurementNo}
        />
        <Label>費目</Label>
        <ExpenseSelect
          value={[searchCondition.expense]}
          onChange={handleExpense}
        />
        <Label>費目要否</Label>
        <NormalStatusSelect
          multiple
          value={searchCondition.expenseNotApplicableFlg?.map((item: number) =>
            item.toString()
          )}
          onChange={handleExpenseNotApplicableFlg}
        />

        <Label>更新ステータス</Label>
        <StatusSelect
          multiple
          value={searchCondition.updSts}
          onChange={handleUpdSts}
        />
        <Label>進捗状況</Label>
        <ProgressStatusSelect
          multiple
          value={searchCondition.opportunityProgressKbn}
          onChange={handleOpportunityProgress}
        />
        <Label>評価</Label>
        <EvaluationSelect
          multiple
          value={searchCondition.evaluationValue}
          onChange={handleEvaluationValue}
        />
        <Label>支店</Label>
        <BranchSelect
          multiple
          onChange={handleBranch}
          value={searchCondition.branch}
          autoClose={false}
        />
        <Label>工事名</Label>
        <Input
          onChange={handleConstrucionNm}
          value={searchCondition.constructionNm}
        />
        <Label>工事種別</Label>
        <ConstrTypeSelect
          multiple
          onChange={handleConstructionCd}
          value={searchCondition.constructionCd}
        />
        <Label>工期</Label>
        <ConstructionPeriodYearsDropDownList
          startOrigin={-3}
          startRange={14}
          endOrigin={-3}
          endRange={24}
          startYearValue={searchCondition.scheduleFrom !== undefined &&
            searchCondition.scheduleFrom !== null
            ? searchCondition.scheduleFrom
            : undefined}
          endYearValue={searchCondition.scheduleFrom !== undefined &&
            searchCondition.scheduleTo !== null
            ? searchCondition.scheduleTo
            : undefined}
          clear={true}
          onStartYearChange={handleStartScheduleFrom}
          onEndYearChange={handleScheduleTo}
        />
        <Label>所長</Label>
        <Input onChange={handleChief} value={searchCondition.chief} />
        <Label>担当者</Label>
        <Input onChange={handlePerson} value={searchCondition.person} />
        <Label>業者</Label>
        <Input onChange={handleSupplierNm} value={searchCondition.supplierNm} />
      </StackLayout>
    </>
  )
}
